module.exports = __webpack_public_path__ + "media/images/athletes/3550-1417d78b8fd2a23c57a813f8246f3d39.png";